import { toast } from 'react-toastify';

export const uiNotify = n => (dispatch, getState) => {
  
  const type = n.type || 'info'

 return toast(n.text);
}